import { connect } 		from 'react-redux'
import Register 		from '../Register';
import {logInAction} 	from '../../actions/authActions'

const mapStateToProps = state => {
  return {
    account: state.account
  }
}

const mapDispatchToProps = dispatch => {
    return {
      logIn: (email, password) => {
        dispatch(logInAction(email, password))
      }
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Register);



// WEBPACK FOOTER //
// ./src/components/containers/RegisterContainer.js